

import React from 'react';
import ReactDOM from "react-dom";


/* =========================================================
   FOOTER
========================================================= */

const Footer = ({ data }) => (
    <footer>

        <div className="container">

            <div className="footer-grid">

                <div>

                    <div className="logo">
                        {data.logo || <>STEM<span>X365</span></>}
                    </div>

                    <p className="footer-description">
                        {data.description}
                    </p>

                </div>

                {(data.columns || []).map((column, i) => (
                    <div key={i}>

                        <h4>{column.title}</h4>

                        {(column.links || []).map((link, j) => (
                            <a key={j} href={link.url || "#"}>
                                {link.text}
                            </a>
                        ))}

                    </div>
                ))}
                <div>
                      <h4>Others</h4>
                      <a href="/rect/html/privacy">Privacy Policy</a>
                      <a href="/rect/html/terms">Terms & Conditions</a>

                    </div>

            </div>
             

            <div className="copyright">
                {data.copyright || "© 2026 STEMX365. All rights reserved."}
            </div>

        </div>

    </footer>
);

export default Footer;